import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "../hooks/apiRequest";
import { SprintProps } from "../types/interfaces";
import { sprintKeys } from "../utils/queryKeys";

export function useSprints(projectId: string) {
  return useQuery({
    queryKey: sprintKeys.list(projectId),
    queryFn: async () => (await apiRequest<SprintProps[]>(`projects/${projectId}/sprints`)).data,
    enabled: !!projectId,
  });
}

export function useCreateSprint(projectId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { name: string; goal?: string; startDate: string; endDate: string }) =>
      (await apiRequest<SprintProps>(`projects/${projectId}/sprints`, {
        method: "POST",
        body: JSON.stringify(data),
      })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: sprintKeys.list(projectId) }),
  });
}
